import axios from "axios";
import { domain } from "../../Links/Links";

export async function TokenRequest(token, setData) {
    
    const response = await axios.get(domain + '/token/?token=' + token, {
        withCredentials: true,
    })

    console.log(response.data);

    if (response.data) {
        setData(response.data);
    }
} 